const initialState = {
  loading: false,
  data: [],
  totals: { total_qty: 0, total_weight: 0, total_pure_weight: 0 },
  error: null,
};

const goldStockAddedReportReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'GOLD_STOCK_ADDED_REPORT_REQUEST':
      return { ...state, loading: true, error: null };
    case 'GOLD_STOCK_ADDED_REPORT_SUCCESS':
      return { ...state, loading: false, data: action.payload.rows, totals: action.payload.totals };
    case 'GOLD_STOCK_ADDED_REPORT_FAILURE':
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

export default goldStockAddedReportReducer; 